import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Modal,
  Typography,
  Button,
  DatePicker,
  notification,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import ProductApi from "../../Apis/ProductApi";
import StockApi from "../../Apis/StockApi";
import AllergenStock from "../../DropDowns/Stock/AllergenStock";
import StorageListApi from "../../Apis/StorageListApi";
const { Title } = Typography;
function EditStock({ visible, onClose, ProductDetails }) {
  const navigate = useNavigate();
  const [formAdd] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);
  const [Products, setProducts] = React.useState([]);
  const [storages, setStorages] = React.useState([]);
  const [storagesLoading, setStoragesLoading] = useState(false);


  const fetchDepartments = async () => {
    try {
      ProductApi.Listproducts(page, 500)
        .then((response) => {
          // setDepartments(response?.payloadDto);
          setTotalPageNew(response.totalPages);
          setProducts(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

          setPage(prevPage => prevPage + 1);

        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error('Error fetching departments:', error);
    } finally {
    }
  };

  const getStorages = useCallback(() => {
    setStoragesLoading(true);
    StorageListApi.ListStorage()
      .then((response) => {
        setStorages(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setStoragesLoading(false);
      });
  }, []);

  formAdd.setFieldsValue({
    productId: ProductDetails ? (ProductDetails?.productDTOs[0]?.id) : '',
    batchCode: ProductDetails?.batchCode,
    invoiceNumber: ProductDetails?.invoiceNumber,
    unitOfMeasurement2: ProductDetails?.unitOfMeasurement2,
    unitOfMeasurement1: ProductDetails ? (parseFloat(ProductDetails?.initQuantity) / parseFloat(ProductDetails?.productDTOs[0]?.unitOfMeasurement2)) : '',
    Allergen: ProductDetails?.allergensDTOList?.map(item => item.id),
    OUBD: dayjs(ProductDetails?.expiryDate),
    expiryDate: dayjs(ProductDetails?.expiryDate),
    unit: ProductDetails ? (ProductDetails?.productDTOs[0]?.unitUomOne) : '',
    supplierId: ProductDetails ? (ProductDetails?.productDTOs[0]?.supplierId) : '',
    institutionId: ProductDetails ? (ProductDetails?.productDTOs[0]?.institutionId) : '',
    storageId: ProductDetails ? (ProductDetails?.storageId) : ''
  });



  useEffect(() => {
    if (TotalPageNew >= page) {
      fetchDepartments();
    }
    getStorages();
  }, [getStorages]);


  const handleInputKeyDown = (event) => {
    if (event.key === '-') {
      event.preventDefault();
    }
  };

  const handleSubmit = (data) => {
    const expiryDateN = moment(data.expiryDate).format("DD/MM/YYYY");
    const uom2 = data.unitOfMeasurement2 === undefined ? 0 : data.unitOfMeasurement2;

    let formData = JSON.stringify({
      unitOfMeasurement1: ProductDetails?.unitOfMeasurement1,
      initQuantity: parseFloat(data.unitOfMeasurement1) * parseFloat(ProductDetails?.productDTOs[0]?.unitOfMeasurement2) + parseFloat(uom2),
      version: ProductDetails?.version,
      invoiceNumber: ProductDetails.invoiceNumber,
      // openUBD: convertToUnixTimestamp(dayjs(data.OUBD).format("DD/MM/YYYY")),
      expiryDate: convertToUnixTimestamp(dayjs(data.OUBD).format("DD/MM/YYYY")),
      batchCode: data.batchCode,
      unit: ProductDetails?.productDTOs[0]?.unitUomTwo,
      productDTO: {
        id: data.productId,
      },
      productDTOs: [{
        id: data.productId,
      }],
      // allergensDTO: data.Allergen.map((number) => ({ id: number })),
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      storageId: data.storageId,
    });
    StockApi.UpdateStock(ProductDetails?.id, formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Updated Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        handleCancel();
        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
        return navigate("/stock?invoice_id=" + ProductDetails?.invoiceNumber);
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  function convertToUnixTimestamp(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }

  const handleCancel = () => {
    formAdd.resetFields();
    onClose();

  };

  return (
    <>
      <Modal
        footer={[]}
        width={600}
        visible={visible}
        maskClosable={false}
        onCancel={handleCancel}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Edit stock
        </Title>
        <Form
          form={formAdd}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 9,
          }}
          wrapperCol={{
            span: 15,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>

            <div className="Ingrefiant-form">
              <Form.Item
                name="productId"
                label="Product Name :"
                className="text-lable disabled"
                rules={[
                  {
                    required: true,
                    message: "Please enter Product Name.",
                  },
                ]}
              >
                {Products && (
                  <>

                    <Select
                      disabled
                      showSearch
                      className="select-multi"
                      placeholder="Select Product"
                      filterOption={(input, option) =>
                        option.props.children && option.props.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {Products.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                          {option.productName}
                        </Select.Option>
                      ))}
                    </Select>
                  </>
                )}
              </Form.Item>
            </div>
            <Form.Item
              name="batchCode"
              label="Batch Code"
              className="text-lable disabled pt-3"
              rules={[
                {
                  required: true,
                  message: "Please enter Batch Code.",
                },
              ]}
            >
              <Input
                type="text"
                disabled
                placeholder="Batch Code"
                className="control-input"
              />
            </Form.Item>
            <Form.Item
              name="invoiceNumber"
              label="Invoice Number"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Please enter Invoice Number.",
                },
              ]}
            >
              <Input
                type="text"
                disabled
                placeholder="Invoice Number"
                className="control-input"
              />
            </Form.Item>

            <div className="row product-row d-flex ">
              <div className="col-2 StockCol"></div>
              <div className="col-4">
                <Form.Item
                  name="unitOfMeasurement1"
                  label="UoM 1"
                  className="text-lable"
                  style={{ width: '100%' }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter unit of measurement 1.",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    style={{ textAlign: 'end' }}
                    placeholder="0"
                    min={0}
                    onKeyDown={handleInputKeyDown}
                    className="control-input"
                  />
                </Form.Item>
              </div>
              <div className="col-5 pr-0" style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ fontSize: '18px' }}> {ProductDetails ? (ProductDetails?.productDTOs[0]?.unitUomOne) : ''}</p>
              </div>
            </div>

            <div className="row product-row d-flex ">
              <div className="col-2 StockCol"></div>
              <div className="col-4">
                <Form.Item
                  name="unitOfMeasurement2"
                  label="UoM 2"
                  className="text-lable"
                >
                  <Input
                    type="number"
                    style={{ textAlign: 'end' }}
                    placeholder="0"
                    min={0}
                    onKeyDown={handleInputKeyDown}
                    className="control-input"
                  />
                </Form.Item>
              </div>
              <div className="col-5 pr-0" style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ fontSize: '18px' }}> {ProductDetails ? (ProductDetails?.productDTOs[0]?.unitUomTwo) : ''}</p>
              </div>
            </div>
            {/* <AllergenStock product={ProductDetails ? (ProductDetails?.productDTOs[0]?.allergens) : []} /> */}

            {/* <div className="row product-row d-flex pt-1">

              <div className=" col-2 StockCol"></div>
              <div className=" col-4">
                <Form.Item
                  name="unitOfMeasurement2"
                  label="UoM 2"
                  className="text-lable  "
                  rules={[
                    {
                      required: true,
                      message: "Please enter unit of measurement 2.",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    placeholder="Unit of Measurement 2"
                    className="control-input"
                  />
                </Form.Item>
              </div>
              <div className="col-5 pr-0">
                <Form.Item
                  name="unit2"
                  label="Unit"
                  className="text-lable "
                >
                  <Select
                    className="control-Select mb-3"
                    placeholder="Select Unit"
                  >
                    <option value="Kg"> Kg</option>
                    <option value="G"> G</option>
                    <option value="L"> L</option>
                    <option value="ML"> ML</option>
                    <option value="BOX"> BOX</option>
                    <option value="PACKET"> PACKET</option>
                    <option value="PIECE"> PIECE</option>
                  </Select>
                </Form.Item>
              </div>
            </div> */}



            <Form.Item
              name="OUBD"
              label={<><div ><p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}><p className="mb-0 pb-0" style={{ color: 'black', fontSize: '15px' }}>OUBD</p>(Original Used by Date)</p></div></>}
              // initialValue={dayjs(currentDate, "DD/MM/YYYY")}
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please Select OUBD.",
                },
              ]}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                placeholder="dd/mm/yyyy"
                className="form-control control-input"
              />
            </Form.Item>


            <Form.Item
              name="storageId"
              label="Storage"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please select storage.",
                },
              ]}
            >
              <Select
                placeholder="Select storage location"
                loading={storagesLoading}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {storages
                  .filter(
                    (option) =>
                      !(option.temperatureMinInCelsius === 0 &&
                        option.temperatureMaxInCelsius === 0)
                  )
                  .map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name} ({option.temperatureMinInCelsius} - {option.temperatureMaxInCelsius} °C)
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* 
            <div className="row product-row d-flex align-items-center">
              <Form.Item
                name="supplierId"
                label="Supplier :"
                className="text-lable pt-1 col-10"
                rules={[
                  {
                    required: true,
                    message: "Please Select Supplier.",
                  },
                ]}
              >
                <Select
                  className="control-Select mb-1 "
                  placeholder="Select Supplier Name"
                >
                  {Suppliers && (
                    <>
                      {Suppliers?.map((option, index) => (
                        <option key={index} value={option?.id}>
                          {option?.supplierName}
                        </option>
                      ))}
                    </>
                  )}
                </Select>
              </Form.Item>
              <div className=" col-1 d-flex justify-content-center">
                {IsReloadSupplierClicked ? (
                  <div className="refresh-btn">
                    <SyncOutlined spin className="px-2" />
                  </div>
                ) : (
                  <div
                    className="refresh-btn"
                    onClick={handleReloadSupplierClick}
                    style={{ cursor: "pointer" }}
                  >
                    <ReloadOutlined className="px-2" />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-4"></div>
              <div className="col-6" style={{ paddingLeft: "30px" }}>
                <Link to={"/masters/suppliers/add-Supplier"} target="_blank">
                  <u>Create New Supplier</u>
                </Link>
              </div>
            </div>

            <div className="row product-row d-flex align-items-center">
              <Form.Item
                name="institutionId"
                label="Department :"
                className="text-lable pt-3 col-10"
                rules={[
                  {
                    required: true,
                    message: "Please Select Department.",
                  },
                ]}
              >
                <Select
                  className="control-Select mb-1 "
                  placeholder="Select Department"
                >
                  {Departments && (
                    <>
                      {Departments?.map((option, index) => (
                        <option key={index} value={option?.id}>
                          {option?.institutionName}
                        </option>
                      ))}
                    </>
                  )}
                </Select>
              </Form.Item>
              <div className=" col-1 d-flex justify-content-center">
                {IsReloadDepartmentClicked ? (
                  <div className="refresh-btn">
                    <SyncOutlined spin className="px-2" />
                  </div>
                ) : (
                  <div
                    className="refresh-btn"
                    onClick={handleReloadDepartmentClick}
                    style={{ cursor: "pointer" }}
                  >
                    <ReloadOutlined className="px-2" />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-4"></div>
              <div className="col-6" style={{ paddingLeft: "30px" }}>
                <Link
                  to={"/masters/departments/add-department"}
                  target="_blank"
                >
                  <u>Create New Department</u>
                </Link>
              </div>
            </div> */}

            {/* <div className="row product-row d-flex align-items-center">
              <Form.Item
                name="Allergen"
                label="Allergen :"
                className="text-lable pt-3 col-10"
                rules={[
                  {
                    required: true,
                    message: "Please Select Allergen.",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  className="control-Select mb-1 "
                  placeholder="Select Allergens"
                  onChange={(value) =>
                    handleChangeAllergens(
                      value
                    )
                  }
                >
                  {Allergens && (
                    <>
                      {Allergens?.map((option, index) => (
                        <option key={index} value={option?.id}>
                          {option?.allergensName}
                        </option>
                      ))}
                    </>
                  )}
                </Select>
              </Form.Item>
              <div className=" col-1 d-flex justify-content-center">
                {IsReloadAllergensClicked ? (
                  <div className="refresh-btn">
                    <SyncOutlined spin className="px-2" />
                  </div>
                ) : (
                  <div
                    className="refresh-btn"
                    onClick={handleReloadAllergensClick}
                    style={{ cursor: "pointer" }}
                  >
                    <ReloadOutlined className="px-2 " />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-4"></div>
              <div className="col-6" style={{ paddingLeft: "30px" }}>
                <Link to={"/masters/allergens/add-allergens"} target="_blank">
                  <u>Create New Allergens</u>
                </Link>
              </div>
            </div> */}


            <div className="d-flex justify-content-center pt-4">
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
              >
                Update
              </Button>
              <Link
                type="primary"
                to={""}
                className="btn btn-primary btn-back mx-2 w-20"
                style={{ width: "37%" }}
                onClick={handleCancel}
              >
                Cancel
              </Link>
            </div>
          </>
        </Form>
      </Modal>
    </>
  );
}

export default EditStock;
